var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Asset',{directives:[{name:"apply-theme",rawName:"v-apply-theme"}],staticClass:"checkout-header-logo",attrs:{"name":"logo.svg","alt":"Logo Parcelex","title":"Logo Parcelex"}})
}
var staticRenderFns = []

export { render, staticRenderFns }